<template>
  <div class="container">
      <div class="top">
        <img class="logo-profile" src="../assets/images/logo_profile.png">
        <p class="photo">
            <img :src="userInfo.photo">
        </p>
        <p>姓名：<span class="userName">{{userInfo.uname}}</span>职务：<span>防水大师</span></p>
        <p>工号：<span>131025</span></p>
        <p>电话：<span><a :href="'tel:'+userInfo.phone" class="phone">{{userInfo.phone}}</a></span></p>
        <p class="stars">
            <img class="star" :src="userInfo.starImg" v-for='(item,index) of userInfo.stars' :key='index'>
        </p>
      </div>
      <div class="contact">
            <p>
                <span>服务热线:</span>
                <span>400-770-8966</span>
            </p>
            <p class="qr">
                <img src="../assets/images/qr.jpg">
                <span>官方微信</span>
            </p>
      </div>
  </div>
</template>

<script>
    import axios from 'axios'
    export default {
        name: "profile",
        data:function(){
            return{
                userInfo:{
                    uname:'王宝强',
                    phone:'13833851886',
                    photo:require("../assets/images/constructionphoto.jpg"),
                    starImg:require("../assets/images/star.png"),
                    stars:5
                }
            }
        },
        created(){
            var id=this.$route.query.id;
            console.log(id);
            axios.get('/dingCMS/webconstruction/show', {
            　　params: { 'id': id }
            }).then((res)=>{
                console.log(res.data)
                if(res.data.detailMsg.data != null){
                  var data=res.data.detailMsg.data;
                  if(data.teamname){ //如果有姓名,替换默认姓名
                      this.userInfo.uname=data.teamname;
                  }
                  if(data.phone){ //如果有电弧,替换默认电话
                      this.userInfo.phone=data.phone;
                  }
                  if(data.rate){ //如果有星级,四舍五入
                      this.userInfo.stars=Math.round(data.rate);
                  }
                  if(data.photo){ //如果有头像,替换默认头像
                      this.userInfo.photo='http://dmzoss.iyuhong.com.cn/' + data.photo + '?imageView2/1/w/148/h/206';
                  }
                }
            }).catch(function (err) {
            　　console.log(err)
            });
        }
    }
</script>

<style scoped>
  .container{
    font-size:5.5vw;
    margin-top:-9vh;
    height:100vh;
    background-color:#fff;
    font-family: "Microsoft YaHei", "SimSun", Helvetica, Arial, sans-serif;
  }
  .logo-profile{width:38vw;margin-left:8vw;vertical-align:top;}
  .photo{text-align:center;margin-bottom:3vh;}
  .photo>img{
      width:147.5px;
      height:206.5px;
      margin-top:3vh;
  }
  .userName{margin-right:5vw;}
  .phone{color:rgb(28,28,28);}
  p{
      text-align:left;
      padding:0 10vw;
      font-weight:bold;
      margin:1vh;
      color:#000;
      font-size:18px;
  }
  p>span{
      font-weight:normal;
      color:rgb(28,28,28);
      font-family: "Microsoft YaHei";
  }
  .stars{
      text-align:center;
      margin:3vh 0 2vh;
      padding:0;
  }
  .star{
      width:30px;
      height:30px;
      margin-left:1vh;
      margin-right:1vh;
  }
  .contact{
      background:rgb(232,17,25);
      display:flex;
      justify-content:space-between;
      padding-left:5vh;
      padding-right:5vh;
      /* height:20vh */
  }
  .contact>p{
      display:flex;
      margin:0;
      padding:0;
      height:15vh;
      margin-top:7vh;
  }
  .contact>p:first-child{flex-direction:column;}
  div.contact p span{
      color:#fff;
  }
  .qr>img{
      width:8vh;
      height:8vh;
  }
  .qr span{
      display:inline-block;
      width:5vh;
      height:6vh;
      margin:1vh 0 1vh 1vh;
      text-align:center;
      font-size:14px !important;
      font-weight:normal !important;
  }
  div.contact p span:first-child{
      font-size:4vw;
  }
  div.contact p span:last-child{
      font-size:7vw;
      font-weight:bold;
  }
</style>



// WEBPACK FOOTER //
// src/components/profile.vue